<template>
  <div>
    <v-layout
      v-if="componentLoading"
      row
      wrap
      justify-center
    >
      <v-progress-circular
        :size="64"
        :width="3"
        indeterminate
        color="primary"
      />
    </v-layout>
    <v-layout
      v-else
      row
      wrap
    >
      <v-flex xs12>
        <v-card
          id="inviteDetails"
          class="max-shadow"
        >
          <v-toolbar
            :class="{ 'elevation-2': scrolled}"
            color="white"
            height="64"
            flat
          >
            <v-btn
              icon
              @click="navigateBack"
            >
              <v-icon color="iconColor">
                arrow_back
              </v-icon>
            </v-btn>
            <v-toolbar-title>
              Invite Details
            </v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-btn
                v-if="!readOnly"
                flat
                large
                color="primary"
                @click="saveVisitor"
              >
                Save
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-layout
            row
            wrap
          >
            <v-flex xs3>
              <v-layout
                column
                align-center
                class="pa-4 ml-3"
              >
                <avatar
                  :src="inviteItem.photoUri"
                  :text="inviteItem.name"
                  :size="160"
                />
                <!-- <v-btn
                color="primary"
                flat
                @click.stop="openFileDialog">upload photo</v-btn> -->
              </v-layout>
            </v-flex>
            <v-layout
              v-scroll:#inviteDetailsForm="onScroll"
              column
            >
              <v-flex
                xs12
                class="pa-4"
              >
                <v-form
                  id="inviteDetailsForm"
                  ref="form"
                  class="form"
                >
                  <v-text-field
                    id="full_name"
                    :value="inviteItem.name"
                    :disabled="readOnly"
                    name="visitorName"
                    label="Visitor Name"
                    required
                  />
                  <phone-field
                    id="phone"
                    v-model="inviteItem.phone"
                    default-country-code="IN"
                    disabled
                  />
                  <v-text-field
                    id="email"
                    :value="inviteItem.email"
                    :disabled="readOnly"
                    name="visitorEmail"
                    label="Visitor Email"
                    required
                  />
                  <v-text-field
                    id="company"
                    :value="inviteItem.company"
                    :disabled="readOnly"
                    name="company"
                    label="Company"
                    required
                  />
                  <v-textarea
                    id="comments"
                    :value="inviteItem.comments"
                    :disabled="readOnly"
                    rows="3"
                    auto-grow
                    label="Comments"
                    name="comments"
                    persistent-hint
                    hint="Helps to convey the purpose of this invite"
                  />
                  <v-text-field
                    id="purpose"
                    :value="inviteItem.visitorType"
                    name="purpose"
                    label="Purpose"
                    disabled
                  />
                  <v-text-field
                    :value="toDate(inviteItem.expectedAt)"
                    name="expectedAt"
                    label="Expected At"
                    disabled
                  />
                  <template v-if="inviteItem.host && $store.state.profile.role !== 'employee'">
                    <v-text-field
                      :value="inviteItem.host.name"
                      name="host"
                      label="Host"
                      disabled
                    />
                  </template>
                  <div
                    v-for="field in inviteItem.fields"
                    :key="field.type"
                  >
                    <template v-if="field.type === 'text_field'">
                      <v-text-field
                        :id="field.id"
                        v-model="field.value"
                        :label="field.label"
                        :disabled="readOnly"
                        :rules="[
                          (v) => {return requiredCheck(v, field);}
                        ]"
                        :type="field.input_type"
                      />
                    </template>
                    <template v-if="field.type === 'single_choice'">
                      <p
                        class="subheading"
                        style="margin-bottom:0"
                      >
                        {{ field.label }} <span
                          v-if="field.required"
                          style="color: red"
                        >
                          *
                        </span>
                      </p>
                      <v-radio-group
                        :id="field.id"
                        v-model="field.value"
                        :disabled="readOnly"
                        :rules="[
                          (v) => {return requiredCheck(v, field);}
                        ]"
                        style="margin-top:0"
                      >
                        <div
                          v-for="option in field.options"
                          :key="option.value"
                        >
                          <v-radio
                            :label="option.value"
                            :value="option.value"
                            color="primary"
                          />
                        </div>
                      </v-radio-group>
                    </template>
                    <template v-if="field.type === 'multi_choice'">
                      <p
                        class="subheading"
                        style="margin-bottom:0"
                      >
                        {{ field.label }} <span
                          v-if="field.required"
                          style="color: red"
                        >
                          *
                        </span>
                      </p>
                      <v-radio-group
                        :id="field.id"
                        :rules="[
                          (v) => {return requiredCheck(v, field);}
                        ]"
                        :disabled="readOnly"
                        style="margin-top:0"
                      >
                        <checkbox-group
                          v-model="field.value"
                          :options="field.options"
                        />
                      </v-radio-group>
                    </template>
                    <template v-if="field.type === 'dropdown'">
                      <v-select
                        :id="field.id"
                        v-model="field.value"
                        :items="field.options"
                        :label="field.label"
                        :disabled="readOnly"
                        :rules="[
                          (v) => {return requiredCheck(v, field);}
                        ]"
                        item-text="value"
                      />
                    </template>
                  </div>
                </v-form>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card>
        <v-snackbar
          v-model="snackbar"
          :color="snackbarColor"
          :timeout="0"
          bottom
        >
          {{ snackbarMessage }}
          <v-btn
            flat
            @click.native="snackbar = false"
          >
            Close
          </v-btn>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import _get from 'lodash/get';
import _cloneDeep from 'lodash/cloneDeep';
import { database } from '@/firebase';
import * as moment from 'moment';
import md5 from 'md5';
import Avatar from '@/components/common/Avatar';
import checkboxGroup from '@/components/common/CheckboxGroup';
import PhoneField from '@/components/common/PhoneField';

export default {
  name: 'Invite',
  components: {
    avatar: Avatar,
    'checkbox-group': checkboxGroup,
    'phone-field': PhoneField
  },
  props: {
    inviteid: {
      type: String,
      default: null,
      required: true
    }
  },
  data() {
    return {
      inviteItem: {},
      componentLoading: true,
      readOnly: false,
      scrolled: false,
      offsetTop: 0,
      snackbarMessage: '',
      snackbarColor: 'primary',
      snackbar: false
    };
  },
  computed: {
    locationId() {
      return _get(this.$store.state.VMS, 'lid');
    },
    fileName() {
      return md5(this.inviteItem.phone);
    },
    profile() {
      return _get(this.$store.state, 'profile');
    }
  },
  watch: {
    locationId: {
      handler(val) {
        if (!val) return;
        this.fetchLogItem();
        this.readOnly = this.profile.role === 'admin';
      },
      immediate: true
    },
    offsetTop: {
      handler(val) {
        if (val > 20) {
          this.scrolled = true;
        } else {
          this.scrolled = false;
        }
      },
      immediate: true
    }
  },
  methods: {
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
    fetchLogItem() {
      let path;
      path =
        this.profile.role === 'admin'
          ? `vms/${this.locationId}/tenants_data/${this.profile.cid}/invites/${
              this.inviteid
            }`
          : `vms/${this.locationId}/invites/${this.inviteid}`;
      database
        .ref(path)
        .once('value')
        .then(inviteItemSnapshot => {
          if (inviteItemSnapshot) {
            const inviteItem = inviteItemSnapshot.val();
            this.inviteItem = inviteItem;
            const checkExpiry = moment(moment().toISOString()).isSameOrAfter(
              inviteItem.expiresAt
            );
            if (inviteItem.used === undefined && checkExpiry) {
              this.readOnly = true;
            } else if (inviteItem.used) {
              this.readOnly = true;
            } else {
              this.readOnly = false;
            }
            this.componentLoading = false;
          }
        });
    },

    _toArray(obj) {
      if (!obj) return [];
      return Object.keys(obj).map(key => {
        const item = obj[key];
        item.id = key;
        return item;
      });
    },

    navigateBack() {
      this.$router.back();
    },
    updatedUrl(val) {
      this.inviteItem.photoUri = val;
    },

    requiredCheck(value, field) {
      if (field.required) {
        if (!value) return 'Field is required';
        return true;
      }
      return true;
    },

    saveVisitor() {
      const nameField = this.$el.querySelector('#full_name');
      const emailField = this.$el.querySelector('#email');
      const companyField = this.$el.querySelector('#company');
      const commentsField = this.$el.querySelector('#comments');

      if (this.$refs.form.validate()) {
        const fields = _cloneDeep(this.inviteItem.fields);

        const fullName = nameField.value;
        const email = emailField.value;
        const company = companyField.value;
        const comments = commentsField.value;

        this.inviteItem.name = fullName.trim();
        this.inviteItem.email = email.trim() || null;
        this.inviteItem.company = company || null;
        this.inviteItem.fields = fields || null;
        this.inviteItem.comments = comments;

        this.inviteItem.photoUri = this.inviteItem.photoUri
          ? this.inviteItem.photoUri
          : null;
        const inviteItem = _cloneDeep(this.inviteItem);
        const path = `vms/${this.locationId}/invites/${this.inviteid}`;
        database
          .ref(path)
          .set(inviteItem)
          .catch(error => {
            this.snackbarMessage = error;
            this.snackbarColor = 'error';
            this.snackbar = true;
          });
        this.navigateBack();
      }
    },

    // openFileDialog() {
    //   this.$refs.photo.changePhoto();
    // },

    dashedString(str) {
      return str.replace(/\s+/g, '-').toLowerCase();
    },

    toDate(millis) {
      if (millis) {
        return moment(millis).format('DD MMM YYYY h:mm A');
      }
      return '';
    }
  }
};
</script>
<style>
#inviteDetails {
  height: calc(100vh - var(--toolbar-height));
  overflow: hidden;
}
#inviteDetails .form {
  height: calc(100vh - var(--form-height));
  overflow-y: scroll;
}
</style>

